import { Component, Input } from '@angular/core';

@Component({
  selector: 'dynfilter-select',
  template: require('./dynamic-filters.select.component.html')
})
export class DynamicFilterSelectComponent {
  @Input() filter: any;

  value: any;

  constructor() {}

  ngOnInit(): void {
    this.value = this.filter.value?.id || '';
  }

  selectedElement = {
    onSelect: (item: any) => {
      this.filter.value = item;
    }
  };
}
